import { useState } from 'react';
import { services } from '../../../mocks/homeData';

const ServicesSection = () => {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <section id="services" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="text-amber-700 text-xs font-semibold tracking-widest uppercase mb-3">Our Services</p>
            <h2 className="text-4xl md:text-5xl font-bold text-stone-900 leading-tight">
              專業服務項目
            </h2>
            <p className="mt-4 text-stone-500 text-sm leading-relaxed max-w-md">
              從天花板到地板，從牆面到隔間，從系統到訂製，每一道工序我們都以職人精神嚴格把關。
            </p>
          </div>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="hidden md:flex items-center gap-2 text-amber-700 font-semibold text-sm hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解更多 / 索取報價
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line" />
            </div>
          </a>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, idx) => (
            <div
              key={service.id}
              onMouseEnter={() => setHovered(service.id)}
              onMouseLeave={() => setHovered(null)}
              className={`group relative rounded-2xl overflow-hidden cursor-default transition-all duration-300 ${
                idx === 0 ? 'lg:col-span-2' : ''
              }`}
              style={{ minHeight: idx === 0 ? '340px' : '280px' }}
            >
              {/* Background Image */}
              <img
                src={service.imageUrl}
                alt={service.title}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              {/* Overlay */}
              <div className={`absolute inset-0 transition-all duration-300 ${
                hovered === service.id
                  ? 'bg-gradient-to-t from-stone-900/95 via-stone-900/60 to-transparent'
                  : 'bg-gradient-to-t from-stone-900/80 via-stone-900/30 to-transparent'
              }`} />

              {/* Content */}
              <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-7">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-amber-700/90">
                    <i className={`${service.icon} text-white text-lg`} />
                  </div>
                  <h3 className="text-white font-bold text-xl">{service.title}</h3>
                </div>
                <p className={`text-white/80 text-sm leading-relaxed transition-all duration-300 ${
                  hovered === service.id ? 'opacity-100 max-h-20' : 'opacity-0 max-h-0 overflow-hidden'
                }`}>
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-10 text-center md:hidden">
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-amber-700 text-white font-semibold text-sm hover:bg-amber-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            索取報價
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm" />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
